import { RequestMessage } from '@map/core';
import { QRScannerModule } from './QRScannerModule';

/**
 * A message that initiates a QR scan request.
 */
export class QRScanRequestMessage extends RequestMessage {
  readonly tag: string = QRScannerModule.scanRequestMessageTag;
}
